import React, { useContext } from 'react';
import { isEmpty } from 'lodash';
import { MyHomepageContext, useMyHomePageContext } from '@/contexts/MyHomePageContext';
import { Spinner } from '@/components/Spinner/Spinner';
import { TileVisualization } from './TileVisualization';

export const TileConfigEditor = React.memo(() => {
    const baseClassName = 'my-home-page';
    const { isContextLoading } = useContext(MyHomepageContext);
    const { tiles } = useMyHomePageContext() ?? {};

    function loadingTiles() {
        return (
            <>
                {[1, 2, 3, 4].map((_, index) => (
                    <div className={`viz-tile ${baseClassName}__tile`} key={'loading-' + index}>
                        <div className={`${baseClassName}__spinner`} key={index}>
                            <Spinner />
                        </div>
                    </div>
                ))}
            </>
        );
    }

    function defaultTiles() {
        return (
            <>
                {[1, 2, 3, 4].map((ele, index) => (
                    <div className={`${baseClassName}__tile`} key={`tile__${ele}`}>
                        <div key={index} className={`${baseClassName}__default_content`}></div>
                    </div>
                ))}
            </>
        );
    }

    return (
        <div className={`${baseClassName}__tiles-container`}>
            {isContextLoading
                ? loadingTiles()
                : isEmpty(tiles)
                ? defaultTiles()
                : tiles.map((tile, index) => (
                      <TileVisualization
                          key={index}
                          tile={tile}
                          className={!tile.data ? `${baseClassName}__free_tile` : `${baseClassName}__tile`}
                      />
                  ))}
        </div>
    );
});

export default TileConfigEditor;
